import { useEffect, useRef } from 'react';
import { isEqual } from 'lodash';

type UseEffectCallback = Parameters<typeof useEffect>[0];
type UseEffectDeps = Parameters<typeof useEffect>[1];

function useDeepCompareMemoize<T>(value: T) {
  const ref = useRef<T>(null);
  // it can be done by using useMemo as well
  // but useRef is rather cleaner and easier

  if (!isEqual(value, ref.current)) {
    ref.current = value;
  }

  return ref.current;
}

export function useDeepCompareEffect(callback: UseEffectCallback, dependencies: UseEffectDeps): void {
  useEffect(callback, dependencies?.map(useDeepCompareMemoize));
}
